module.exports = __webpack_public_path__ + "static/your-customer@3x-c9602bc398bc1f6727cd3da37c061f47.png";